import { cn } from '@cobliteam/ui/utils';
import type React from 'react';

export interface PageBodyProps {
  children: React.ReactNode;
  className?: string;
  container?: boolean;
}

const PageBody = ({ children, className, container }: PageBodyProps) => {
  return <div className={cn('flex flex-col gap-5', className, container && 'container')}>{children}</div>;
};

export default PageBody;
